import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";
import { Icon } from "../../../../components";
import { Button, H5, H6 } from "@sellar-io/components";

export const DiscoveryHorizontalList = ({
  title,
  subtitle,
  onClick,
  hideViewMore = false,
  children,
  containerClassName,
}: {
  title?: string;
  subtitle?: string;
  onClick?: () => void;
  hideViewMore?: boolean;
  children: ReactNode;
  containerClassName?: string;
}) => {
  const clickable = !!onClick;

  return (
    <div className={twMerge("px-4 pt-4", containerClassName)}>
      <div className="flex flex-col gap-4">
        {(title || subtitle) && (
          <div className="flex flex-col">
            {title && (
              <H5
                className={twMerge(
                  "flex items-center",
                  clickable && "cursor-pointer",
                )}
                onClick={onClick}
              >
                {title} {clickable && <Icon icon={"CHEVRON_RIGHT"} />}
              </H5>
            )}
            {subtitle && (
              <H6 className="text-sm font-normal text-zinc-600">{subtitle}</H6>
            )}
          </div>
        )}
        <div className="flex gap-3 overflow-auto pb-2">
          {children}
          {!hideViewMore && (
            <div className="my-auto mt-[40px] p-8">
              <Button color={"tertiary"} onClick={onClick}>
                View more <Icon icon={"CHEVRON_RIGHT"} />
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
